import { HourlyProductionChart } from "./HourlyProductionChart";
export default HourlyProductionChart;
